export const me = {
  intro:
    "HTML, CSS, JavaScript (ES6), ReactJS, StyledComponent & ExpressJS with MongoDB",
  badges: [
    {
      title: "Linkedin",
      avatar:
        "https://img.shields.io/badge/LinkedIn-0077B5?style=for-the-badge&logo=linkedin&logoColor=white",
      url: "https://www.linkedin.com/in/nishant-kumar-027b5486/?originalSubdomain=in",
    },
    {
      title: "Facebook",
      avatar:
        "https://img.shields.io/badge/Facebook-1877F2?style=for-the-badge&logo=facebook&logoColor=white",
      url: "https://www.facebook.com/Nishant.Kumar337/",
    },
    {
      title: "Instagram",
      avatar:
        "https://img.shields.io/badge/Instagram-E4405F?style=for-the-badge&logo=instagram&logoColor=white",
      url: "https://www.instagram.com/knishant086/",
    },
  ],
  skills: [
    {
      title: "HTML",
      link: "https://html.com/",
    },
    {
      title: "CSS",
      link: "",
    },
    {
      title: "JavaScript",
      link: "",
    },
    {
      title: "React",
      link: "",
    },
  ],
};
